module.exports = __webpack_public_path__ + "img/mobilistico.e1ff84e5.png";